
<template>

  <svg viewBox="0 0 46 48" aria-hidden="true">

    <path d="m45.56 12.94-9-8.5c-.59-.58-1.54-.58-2.12 0-.58.59-.58 1.54 0 2.12l3.56 3.35v4.43c0 1.06.42 2.08 1.17 2.83l3.83 3.83v17.5c0 1.38-1.12 2.5-2.5 2.5s-2.5-1.12-2.5-2.5v-11c0-2.48-2.02-4.5-4.5-4.5h-1.5v-20c0-1.66-1.34-3-3-3h-24c-1.66 0-3 1.34-3 3v41c-1.11 0-2 .9-2 2v2h34v-2c0-1.1-.9-2-2-2v-18h1.5c.83 0 1.5.67 1.5 1.5v11c0 3.03 2.47 5.5 5.5 5.5s5.5-2.47 5.5-5.5v-24.5c0-.4-.16-.78-.44-1.06m-40.56-6.94h24v15h-24v-15z"
    
      fill="currentColor" />

  </svg>

</template>
